const ReplyMixin = {
  props: {
    isBot: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    form() {
      const storeLabel = this.isBot ? 'bot/form' : 'reply/form'
      return this.$store.getters[storeLabel]
    },
  },
}

export default ReplyMixin
